import { faImage } from '@fortawesome/pro-light-svg-icons/faImage'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import SeeAll from '@space-core/components/seeAll'
import SwiperCards from '@space-shell/common/components/swiper'
import type { ShowcaseOrientation } from '@space-shell/common/services/membership'
import type { SectionType } from '@space-shell/common/services/sections'

import SectionTitle from '@space-shell/modules/home/components/sectionsInShowcase/sectionTitle'

import { useTranslation } from 'react-i18next'

import { PLACEHOLDER_CARD_NUMBER } from './constants'
import { CardWrapper } from './sectionPlaceHolderStyles'

export type SectionPlaceholderProps = {
  title: string
  orientation: ShowcaseOrientation
  type: SectionType
}

const SectionPlaceholder = ({ title, orientation, type }: SectionPlaceholderProps) => {
  const { t } = useTranslation()

  return (
    <>
      <div className='_d-flex _align-items-center _justify-content-between'>
        <SectionTitle isDynamicSection sectionType={type} sectionTitle={title} />
        <SeeAll className='_text-3 _pr-4 _pr-md-10 _mb-5' text={t('sections.see_all')} />
      </div>

      <SwiperCards orientation={orientation} sectionType={type} slidesPerPage={4}>
        {Array.from({ length: PLACEHOLDER_CARD_NUMBER }).map((_, index) => (
          <SwiperCards.Item key={index} virtualIndex={index}>
            <CardWrapper $orientation={orientation}>
              <div
                data-test='card-placeholder'
                className='_w-full _bg-gray-200 _h-full _rounded-lg _d-flex _align-items-center _justify-content-center'>
                <FontAwesomeIcon className='_text-gray-500 _text-8' icon={faImage} />
              </div>
            </CardWrapper>
          </SwiperCards.Item>
        ))}
      </SwiperCards>
    </>
  )
}

export default SectionPlaceholder
